export var FormStage;
(function (FormStage) {
    FormStage[FormStage["Date"] = 0] = "Date";
    FormStage[FormStage["Activities"] = 1] = "Activities";
    FormStage[FormStage["Attendees"] = 2] = "Attendees";
    FormStage[FormStage["Session"] = 3] = "Session";
})(FormStage || (FormStage = {}));
export default {
    FormStage,
};
